import { useShowWarning } from '@/hooks';
import { Logos } from './Logos';
import { NavBarMenu } from './NavBarMenu';

export const Header = () => {
  const { data: showWarning } = useShowWarning();
  return (
    <div className="flex w-screen flex-row items-center justify-between border-b-[1px] border-grey-10 bg-white px-8 py-5">
      <Logos />
      {showWarning && (
        <div
          style={{
            background: 'yellow',
            color: 'red',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            width: '1000px', // Adjust width as needed
            borderRadius: '4px',
            textAlign: 'center',
          }}
        >
          <span
            style={{
              display: 'inline-block',
            }}
          >
            <h5>
              This is AWMS (2026 onwards), for AWMS (2023-2025) please visit{' '}
              <a href="https://curtin.edu.au/awms">https://curtin.edu.au/awms</a>
            </h5>
          </span>
        </div>
      )}
      <NavBarMenu />
    </div>
  );
};
